import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { OpenModalContainer } from '../openModalContainer';
import { TourneyDetailsDisplay } from './tourneyDetailsDisplay';
export const TourneyDetailsModal = ({ tourneyDetails, onClose }) => {
    return (_jsx(OpenModalContainer, { title: tourneyDetails.name, onClose: onClose, maxWidth: 'md', children: _jsx(DialogContent, { children: _jsx(Typography, { variant: 'subtitle1', children: _jsx(TourneyDetailsDisplay, { tourneyDetails: tourneyDetails, isSingleView: true }) }) }) }));
};
